import { FormControlLabel, Switch, SxProps, Theme } from "@mui/material"
import { FC } from "react"
import { Control, Controller, RegisterOptions } from "react-hook-form"

interface SwitchWrapperProps {
  name: string
  label?: string

  onChange?: any
  value?: boolean

  control?: Control<any, any>
  rules?: Omit<
    RegisterOptions<Record<string, any>, any>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >
  sx?: SxProps<Theme>
  "data-testid"?: string
}

export const SwitchWrapper: FC<SwitchWrapperProps> = ({
  label = "",
  control = null,
  value = false,
  ...props
}) => {
  if (control) {
    return (
      <>
        <Controller
          name={props.name}
          control={control}
          rules={props.rules}
          render={({ field, fieldState: { error } }) => (
            <FormControlLabel
              control={
                <Switch
                  sx={props.sx}
                  {...field}
                  checked={field?.value || false}
                />
              }
              label={label}
            />
          )}
        />
      </>
    )
  }
  return (
    <Switch
      sx={props.sx}
      value={value}
      checked={value}
      onChange={(event) => {
        props.onChange(event.target.checked)
      }}
    />
  )
}
